import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { decodeJwt } from "./jwt";

export interface LoginState {
    user: string | null;
    token: string | null;
}

const initialState: LoginState = {
    user: null,
    token: null
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        login: (state, action: PayloadAction<string>) => {
            const token = action.payload;
            const claims = decodeJwt(token);
            state.user = claims?.user ?? claims?.username ?? null;
            state.token = token;
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
        }
    }
});

export const { login, logout } = loginSlice.actions;

export const userLoggedIn = (state: RootState) => state.login.token !== null;

// redux-persist injects `_persist.rehydrated` onto the root state once the persisted
// store has finished restoring from localStorage. Until that happens, `state.login.token`
// is just the reducer's initial value (null) and must not be read as "logged out" - doing
// so races PersistGate's own (unreliable) render-blocking and can bounce a logged-in user
// to /login on refresh. Stores without persistence (e.g. tests) have no `_persist` key at
// all, so default to true - there's nothing to wait for.
export const sessionRehydrated = (state: RootState) => (state as any)._persist?.rehydrated ?? true;

export const currentToken = (state: RootState) => state.login.token;

export const currentUser = (state: RootState) => state.login.user;

export default loginSlice.reducer;